// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "h5[data-v-7a3af5ac] {\n  color: var(--green);\n  font-size: 1.13rem;\n}", ""]);
// Exports
module.exports = exports;
